import classNames from 'classnames';
import equal from 'fast-deep-equal/react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeVisiblePopup } from '~/Actions/ActionApp';
import { IChangeVisiblePopup } from '~/Actions/ActionAppType';
import { OrangeButton } from '~/components/Button/Buttons';
import { Popup, PopupHeader, PopupBody, PopupFooter } from '~/components/Popup/Popup';
import { POPUPS_NAME } from '~/components/PopupManager';
import SerialItemsSmallCarouselItem from '~/components/SerialItemsSmallCarousel/SerialItemsSmallCarouselItem';
import useMaskScrollEffect from '~/hooks/useMaskScrollEffect';
import { State } from '~/Reducers';
import { t } from '~/utils/localization';
import styles from './SerialSequencePurchase.scss';
import { IPopupSoundset } from '~/types/soundsets';

interface ISerialSequenceSucessPurchase {
    data: {
        bundleIds: number[];
    };
}

interface IStateSelector {
    bundles: IBundleList;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        bundles: state.ReducerApp.bundles,
    };
};

const AnimatedDiv = ({ children, index }: { children: React.ReactChild; index: number }) => {
    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (!ref.current) {
            return;
        }

        ref.current.classList.add(styles.done);
    }, []);

    return (
        <div
            className={classNames(styles.animatedDiv)}
            style={{ transitionDelay: `0.${index}s` }}
            ref={(_ref) => {
                if (_ref) {
                    ref.current = _ref;
                }
            }}
        >
            {children}
        </div>
    );
};

const SerialSequenceSucessPurchase = ({ data }: ISerialSequenceSucessPurchase) => {
    const dispatch = useDispatch();
    const { bundles } = useSelector<State, IStateSelector>(stateSelector, equal);
    const itemsRef = React.useRef<HTMLDivElement>(null);
    const { bundleIds } = data;
    const sequence = bundleIds.map((bundleId) => bundles[bundleId]);

    const close = () => {
        dispatch<IChangeVisiblePopup>(changeVisiblePopup(null));
    };

    useMaskScrollEffect(itemsRef);

    return (
        <Popup
            onClose={close}
            outsideClick={false}
            renderEscButton={true}
            popupClassName={styles.popupWrapper}
            className={classNames(styles.popup, 'armory__auto--success-purchase-popup')}
            soundset={IPopupSoundset.EXCHANGE}
        >
            <PopupHeader title={t('Спасибо за покупку!')} />
            <PopupBody className={styles.body}>
                <div
                    className={styles.items}
                    ref={(_ref) => {
                        if (_ref) {
                            itemsRef.current = _ref;
                        }
                    }}
                >
                    {sequence.map((bundle, index) => {
                        return (
                            <AnimatedDiv key={`purchase_success_item_${bundle.id}_${bundle.serialIndex}`} index={index}>
                                <SerialItemsSmallCarouselItem className={styles.item} bundle={bundle} showTitle />
                            </AnimatedDiv>
                        );
                    })}
                </div>
            </PopupBody>
            <PopupFooter>
                <OrangeButton label={t('Закрыть')} onClick={close} className={classNames('armory__auto--success_purchase_button')} />
            </PopupFooter>
        </Popup>
    );
};

export default SerialSequenceSucessPurchase;
